<div class="chapter-container" provide-parent-form>
    <bb-chapter-editor *ngIf="mediaclip" [(ngModel)]="mediaclip.chapters" [mediaclip]="mediaclip" name="mediaclip-chapters"></bb-chapter-editor>
</div>
